"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _clone = _interopRequireDefault(require("lodash/clone"));

var _compact = _interopRequireDefault(require("lodash/compact"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var groupExactlyElements = function groupExactlyElements(elements, newTag, tags) {
  if ((0, _isEmpty.default)(elements) || !(0, _isArray.default)(elements)) return elements;
  if (!newTag) return elements;
  if (!(0, _isArray.default)(tags) || tags.length === 0) return elements; // clone arr

  var copy = (0, _clone.default)(elements);
  var groups = [];
  var lastID = null;
  var lastItemIndex = null;
  var tagCounter = 0;
  copy.forEach(function (element) {
    var id = element.id,
        tag = element.tag;
    if (lastItemIndex === null) tagCounter = 0;

    if (lastItemIndex === null && tag === tags[0]) {
      groups.push({
        id: id,
        elements: [element]
      });
      lastID = id;
      lastItemIndex = tagCounter + 1;
    } else if (tag === tags[lastItemIndex]) {
      var index = groups.findIndex(function (group) {
        return group.id === lastID;
      });
      groups[index].elements.push(element);
      lastItemIndex = tagCounter + 1;
    } else {
      lastID = null;
      lastItemIndex = null;
    }

    tagCounter++;
  });
  groups === null || groups === void 0 ? void 0 : groups.forEach(function (group) {
    var startID = group.id,
        elements = group.elements;

    if (elements.length === tags.length) {
      var _group$elements;

      var ids = group === null || group === void 0 ? void 0 : (_group$elements = group.elements) === null || _group$elements === void 0 ? void 0 : _group$elements.map(function (element) {
        return element.id;
      });

      for (var i = 0; i < copy.length; i++) {
        if (copy[i].id === startID) {
          copy[i] = {
            id: startID,
            tag: newTag,
            children: elements
          };
        } else if (ids.indexOf(copy[i].id) > -1) {
          copy[i] = "";
        }
      }
    }
  });
  return (0, _compact.default)(copy);
};

var _default = groupExactlyElements;
exports.default = _default;